export enum StatusServerlessTask {
  ComplateSuccess = 'completed (Succeeded)',
  ComplateFailed = 'completed (Failed)',
  ComplateTimeout = 'completed (Timeout)',
  IncompleteCancel = 'incomplete (Cancel)',
  Timeout = 'timeout',
  Running = 'running',
  Pending = 'pending',
  // new status
  Completed = 'completed',
  WaitingForResource = 'waiting for resource',
  ReachedBudgetLimit = 'completed (reached budget limit)',
  StoppedByUser = 'stopped by user',
  FailedInvalidSyntax = 'failed (invalid syntax)',
  FailedUnexpectedIndent = 'failed (unexpected indent)',
  FailedNameError = 'failed (NameError)',
  FailedSyntaxError = 'failed (SyntaxError)',
  FailedNoModuleNamed = 'failed (No module named)',
}

export const StatusServerlessTaskLabel: Record<StatusServerlessTask, string> = {
  [StatusServerlessTask.Completed]: 'Completed (Spot)',
  [StatusServerlessTask.ComplateSuccess]: 'Completed (On-demand)',
  [StatusServerlessTask.ComplateFailed]: 'Completed (Failed)',
  [StatusServerlessTask.ComplateTimeout]: 'Completed (Timeout)',
  [StatusServerlessTask.IncompleteCancel]: 'Incomplete (Cancel)',
  [StatusServerlessTask.Timeout]: 'Timeout',
  [StatusServerlessTask.Running]: 'Running',
  [StatusServerlessTask.Pending]: 'Pending',
  [StatusServerlessTask.WaitingForResource]: 'Waiting for resource',
  [StatusServerlessTask.ReachedBudgetLimit]: 'Completed (Reached budget limit)',
  [StatusServerlessTask.StoppedByUser]: 'Stopped by user',
  [StatusServerlessTask.FailedInvalidSyntax]: 'Failed (Invalid syntax)',
  [StatusServerlessTask.FailedUnexpectedIndent]: 'Failed (Unexpected indent)',
  [StatusServerlessTask.FailedNameError]: 'Failed (NameError)',
  [StatusServerlessTask.FailedSyntaxError]: 'Failed (SyntaxError)',
  [StatusServerlessTask.FailedNoModuleNamed]: 'Failed (No module named)',
};

export enum TypeServerless {
  Manual = 'manual',
  Server = 'server',
  Function = 'function',
  Spot = 'spot',
}

export const TypeServerlessLabel: Record<TypeServerless, string> = {
  [TypeServerless.Server]: 'Server',
  [TypeServerless.Function]: 'Function',
  [TypeServerless.Manual]: 'Manual',
  [TypeServerless.Spot]: 'Spot',
};

export enum StatusServerlessProject {
  Active = 'active',
  Deleted = 'deleted',
  // Inactive = 'inactive',
}

export const StatusServerlessProjectLabel: Record<
  StatusServerlessProject,
  string
> = {
  [StatusServerlessProject.Active]: 'Active',
  [StatusServerlessProject.Deleted]: 'Deleted',
  // [StatusServerlessProject.Inactive]: 'Inactive',
};

export interface GetServerlessProjectsResponse {
  projects: ServerlessProject[];
}
export interface ServerlessProject {
  project_id: string;
  project_name?: string;
  instance_type: string;
  status: StatusServerlessProject;
  created_at: string;
  updated_at: string;
  has_endpoint?: boolean;
}

export interface GetServerlessProjectByIdResponse {
  project: ServerlessProject;
  details: string;
  status: string;
}

export interface GetServerlessProjectByIdRequest {
  project_id: string;
}

export interface DeleteServerlessProjectRequest {
  project_id: string;
}

export interface DeleteServerlessProjectResponse {}

export interface ServerlessTask {
  id: string;
  name: string | undefined;
  status: StatusServerlessTask;
  created_at: string;
  trigger_type: TypeServerless;
  project_id: string;
}

export interface ListServerlessTasksResponse {
  tasks: ServerlessTask[];
}

export interface ListServerlessTasksRequest {
  project_id?: string;
  trigger_type?: TypeServerless;
}

export interface ServerlessTaskDetails extends ServerlessTask {
  completed_at?: string;
  duration?: number;
}

export interface GetServerlessTaskByIdResponse extends ServerlessTaskDetails {}

export interface GetServerlessTaskByIdRequest {
  task_id: string;
}

export interface GetServerlessTaskLogsRequest {
  task_id: string;
}

export interface GetServerlessTaskLogsResponse {
  task_id?: string;
  log?: string;
}

export interface GetServerlessEndpointByIdRequest {
  project_id: string;
}

export interface ServerlessEndpoint {
  endpoint: string;
  api_key: string;
  deployed_at: string;
  project_id: string;
  is_active: boolean;
}

export interface GetServerlessEndpointByIdResponse extends ServerlessEndpoint {}

export type ServerlessRegenerateApiKeyRequest = {
  project_id: string;
};

export type ServerlessRegenerateApiKeyResponse = {
  api_key: string;
};

export type ServerlessStartEndpointRequest = {
  project_id: string;
};

export type ServerlessStartEndpointResponse = {
  status: string;
};

export type ServerlessStopEndpointRequest = {
  project_id: string;
};

export type ServerlessStopEndpointResponse = {
  status: string;
};

export type ServerlessGetTokenRequest = {
  workspace_id: string;
};

export type ServerlessGetTokenResponse = {
  token: string;
};

export type GetServerlessStorageRequest = {
  project_id: string;
};

export type GetServerlessStorageResponse = {
  files: ServerlessStorageFile[];
  status: string;
  details: string;
};

export type GetServerlessStorageSizeRequest = {
  project_id: string;
};

export type GetServerlessStorageSizeResponse = {
  data: {
    bytes: number;
    size: number;
  };
};

export type ServerlessStorageFile = {
  path_name: string;
  size: number;
  type: string;
  last_modified: string;
};

export type DownloadFileOnRemoteParams = {
  project_id: string;
  file_path: string[];
};

export type DownloadFileOnRemoteResponse = {
  downloads: {
    path: string;
    url: string;
  }[];
};

export type UploadFileOnRemoteParams = {
  project_id: string;
  file_list: {
    file_name: string;
    file_path: string;
  }[];
};

export type UploadFileOnRemoteResponse = {
  uploads: {
    path: string;
    url: string;
  }[];
};

export type RemoveFileOnRemoteParams = {
  project_id: string;
  project_path: string[];
};

export type ServerlessStorageCopyParams = {
  original_path: string;
  destination_path: string;
};

export type ServerlessStorageCopyResponse = {
  status: string;
  details: string;
};

export type ServerlessTaskSpotByIdRequest = {
  task_id: string;
};

export type ServerlessTaskSpotInfo = {
  max_spending: number;
  recorded_spending: number;
  should_stop: boolean;
  execute_file: string;
  project_id: string;
  total_duration: number;
  task_id: string;
  spot_price_per_hour: number;
};

export type ServerlessTaskSpotByIdResponse = ServerlessTaskSpotInfo;

export type ServerlessTaskSpotStopRequest = {
  task_id: string;
};

export type ServerlessTaskSpotStopResponse = void;

export type ServerlessTaskSpotUpdateRequest = {
  task_id: string;
  max_spending?: number;
};

export type ServerlessTaskSpotUpdateResponse = void;

export type GetServerlessMetricsEndpointRequest = {
  project_id: string;
  start_date: string;
  end_date: string;
};

export type MetricsHourlyData = {
  timestamp: string;
  total_usage: number;
  total_requests: number;
};

export type GetServerlessMetricsEndpointResponse = {
  spot_data?: MetricsHourlyData[];
  server_data?: MetricsHourlyData[];
  function_data?: MetricsHourlyData[];
  manual_data?: MetricsHourlyData[];
};

export type GetServerlessMetricsTotalConsumptionRequest = {
  project_id: string;
  start_date: string;
  end_date: string;
};

export type GetServerlessMetricsTotalConsumptionResponse = {
  total_tasks: number;
  total_usage: number;
  total_cost: number;
  cost_breakdown: {
    storage: number;
    on_demand: number;
    spot: number;
  };
  usage_breakdown: {
    on_demand: number;
    spot: number;
  };
};

export type GetServerlessMetricsDailyTasksRequest = {
  project_id: string;
  start_date: string;
  end_date: string;
};

export type GetServerlessMetricsDailyTasksResponse = {
  data: {
    date: string;
    total_tasks: number;
    manual: number;
    function: number;
    server: number;
    spot: number;
  }[];
};

export type GetServerlessMetricsDailyCostRequest = {
  project_id: string;
  start_date: string;
  end_date: string;
};

export type GetServerlessMetricsDailyCostResponse = {
  data: {
    date: string;
    total_cost: number;
    storage: number;
    on_demand: number;
    spot: number;
  }[];
};
export type GetServerlessInstancePricingResponse = {
  data: {
    instance_id: string;
    instance_type: string;
    price_per_hour: number;
    spot_price_per_hour: number;
    storage_price_per_month: number;
    instance_provider: string;
    instance_region: string;
  }[];
};

export interface RunTaskPayload {
  files: Array<{
    name: string;
    content: string; // base64 encoded content
  }>;
  name: string;
  project_id: string;
}

export interface RunTaskResponse {
  task_id: string;
  output: string;
  status: string;
}

export type RunSpotTaskPayload = RunTaskPayload & {
  max_spending?: number;
};

export type RunSpotTaskResponse = {
  task_id: string;
  details: string;
  status: string;
};

export interface StartProjectRequest {
  project_id: string;
  config: {
    project_id?: string;
    mode?: "realtime" | "batch";
  }
  requirements_content: string;
}

export type CreateDeployEndpointParams = {
  project_id: string;
  files: Array<{
    name: string;
    content: string; // base64 encoded content
  }>;
  config: {
    [key: string]: any;
  };
  requirements_content: string;
};

export type CreateDeployEndpointResponse = {
  endpoint_id: string;
  status: string;
  endpoint: string;
  api_key: string;
};

export type CreateProjectRequest = {
  instance_type: string;
  project_name?: string;
};

export type CreateProjectResponse = {
  project_id: string;
};

export type GetServerlessInstanceDefaultResponse = {
  data: {
    instance_type: string;
  };
};

// Parabricks endpoint types
export interface RunParabricksPayload {
  project_id: string;
  command?: 'fq2bam';  // Optional, defaults to 'fq2bam'
  ref: string;         // Path to reference genome (.fasta)
  in_fq: string[];     // Array of input FASTQ file paths
  out_bam: string;     // Output BAM file path
  timeout?: number;    // Optional timeout in seconds
}

